<template>
  <div class="p-3 bg-red">
    <div class="d-flex align-items-center">
      <FeatherIcon
        icon="alert-circle"
        size="24"
        class="mr-2 text-white alert-circle"
      />
      <div class="text-size-14 text-white">{{ details }}</div>
    </div>
    <div class="text-size-12 text-white ml-2 mt-2 mr-2">{{ comment }}</div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

@Component({
  components: {
    FeatherIcon
  }
})
export default class RejectionReason extends Vue {
  @Prop({
    type: String,
    default: ""
  })
  details!: string;

  @Prop({
    type: String,
    default: ""
  })
  comment!: string;
}
</script>

<style lang="scss" scoped>
.alert-circle {
  width: 35px;
}
</style>
